/**
 * Shared responsive fix for Provably Fair modal headers (ProvablyFairModal +
 * ProvablyFairInfoModal), which pack title/multiplier/time/balance/close
 * into one row — too tight on mobile widths, clipping the close button.
 * Header wrap + auto-margin actions group is set inline (JS) on the
 * `data-pf-header` / `data-pf-header-actions` nodes; this only handles the
 * narrow-screen compacting that inline styles can't (media query).
 */
export const PF_HEADER_WALLET_RESPONSIVE_CSS = `
@media (max-width: 420px) {
  [data-pf-header-actions] [data-wallet-balance] {
    height: 28px;
    padding: 0 8px;
  }
  [data-pf-header-actions] [data-wallet-balance] svg {
    display: none;
  }
}
`;
